import React from "react";
import LoadingGIF from "../../assets/blue_loading.gif";
import * as S from "./styles";

const Spinner: React.FC = () => (
  <S.Container>
    <S.ImageContainer>
      <img src={LoadingGIF} alt="로딩중" className="w-16 h-16" />
    </S.ImageContainer>
  </S.Container>
);

export default Spinner;
